/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LivePlayerStatsStrokesGainedForStatQueryVariables = {|
  eventId: string,
  statKey: string,
|};
export type LivePlayerStatsStrokesGainedForStatQueryResponse = {|
  +liveStrokesGainedForStat: ?{|
    +rows: ?$ReadOnlyArray<?{|
      +eventPlayer: ?{|
        +player: {|
          +id: string,
          +nameDisplay: string,
          +firstName: ?string,
          +lastName: ?string,
          +dkPlayer: ?{|
            +id: string
          |},
        |},
        +nextRoundSalary: ?number,
      |},
      +toPar: ?string,
      +roundStats: ?$ReadOnlyArray<?any>,
    |}>,
    +nextRoundSalaryTitle: ?string,
  |}
|};
export type LivePlayerStatsStrokesGainedForStatQuery = {|
  variables: LivePlayerStatsStrokesGainedForStatQueryVariables,
  response: LivePlayerStatsStrokesGainedForStatQueryResponse,
|};
*/


/*
query LivePlayerStatsStrokesGainedForStatQuery(
  $eventId: ID!
  $statKey: String!
) {
  liveStrokesGainedForStat(eventId: $eventId, statKey: $statKey) {
    rows {
      eventPlayer {
        player {
          id
          nameDisplay
          firstName
          lastName
          dkPlayer {
            id
          }
        }
        nextRoundSalary
        id
      }
      toPar
      roundStats
    }
    nextRoundSalaryTitle
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "statKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  },
  {
    "kind": "Variable",
    "name": "statKey",
    "variableName": "statKey"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourPlayerType",
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlayerType",
      "kind": "LinkedField",
      "name": "dkPlayer",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRoundSalary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toPar",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roundStats",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRoundSalaryTitle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LivePlayerStatsStrokesGainedForStatQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourStrokesGainedByRoundSummaryType",
        "kind": "LinkedField",
        "name": "liveStrokesGainedForStat",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourStrokesGainedByRoundType",
            "kind": "LinkedField",
            "name": "rows",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventPlayerType",
                "kind": "LinkedField",
                "name": "eventPlayer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LivePlayerStatsStrokesGainedForStatQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourStrokesGainedByRoundSummaryType",
        "kind": "LinkedField",
        "name": "liveStrokesGainedForStat",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourStrokesGainedByRoundType",
            "kind": "LinkedField",
            "name": "rows",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventPlayerType",
                "kind": "LinkedField",
                "name": "eventPlayer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "db14b82d989e7c38ae2dad737dc40edd",
    "id": null,
    "metadata": {},
    "name": "LivePlayerStatsStrokesGainedForStatQuery",
    "operationKind": "query",
    "text": "query LivePlayerStatsStrokesGainedForStatQuery(\n  $eventId: ID!\n  $statKey: String!\n) {\n  liveStrokesGainedForStat(eventId: $eventId, statKey: $statKey) {\n    rows {\n      eventPlayer {\n        player {\n          id\n          nameDisplay\n          firstName\n          lastName\n          dkPlayer {\n            id\n          }\n        }\n        nextRoundSalary\n        id\n      }\n      toPar\n      roundStats\n    }\n    nextRoundSalaryTitle\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ed13724f90426f6fbe70726f06f61497';

module.exports = node;
